/* Craftsbazaar workshops — scroll reveal + live countdowns. Scoped to .cb-shop. */
(function () {
  'use strict';

  /* ---------- scroll reveal ---------- */
  function initReveal(root) {
    root.classList.add('is-js');
    var els = root.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- countdown ---------- */
  var pad = function (n) { return n < 10 ? '0' + n : '' + n; };

  function paint(el, now) {
    var deadline = el._deadline;
    if (!deadline) return;
    var diff = deadline - now;

    if (diff <= 0) {
      if (!el._closed) {
        el._closed = true;
        var mini = el.classList.contains('count-mini');
        el.classList.add('is-past');
        el.innerHTML = mini
          ? 'Booking closed'
          : '<span>This round has wrapped \u00b7 new dates soon</span>';
        // disable the matching CTA inside the same card
        var card = el.closest('.ws-card, .feature');
        if (card) {
          card.classList.add('is-past');
          var cta = card.querySelector('.ws-cta');
          if (cta && cta.tagName === 'A') {
            cta.setAttribute('aria-disabled', 'true');
            cta.removeAttribute('href');
            cta.textContent = 'Booking closed';
          }
        }
      }
      return;
    }

    var s = Math.floor(diff / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600);  s -= h * 3600;
    var m = Math.floor(s / 60);    s -= m * 60;

    if (el.classList.contains('count-mini')) {
      var parts = [];
      if (d) parts.push(d + 'd');
      parts.push(pad(h) + 'h');
      parts.push(pad(m) + 'm');
      el._txt.textContent = 'Starts in ' + parts.join(' ');
    } else {
      el._d.textContent = pad(d);
      el._h.textContent = pad(h);
      el._m.textContent = pad(m);
      if (el._s) el._s.textContent = pad(s);
    }
  }

  function initCounts(root) {
    var nodes = root.querySelectorAll('.count[data-deadline], .count-mini[data-deadline]');
    var live = [];
    nodes.forEach(function (el) {
      var t = Date.parse(el.getAttribute('data-deadline'));
      if (isNaN(t)) { return; }
      el._deadline = t;
      if (el.classList.contains('count-mini')) {
        el._txt = el.querySelector('.mini-txt') || el;
      } else {
        el._d = el.querySelector('[data-u="d"]');
        el._h = el.querySelector('[data-u="h"]');
        el._m = el.querySelector('[data-u="m"]');
        el._s = el.querySelector('[data-u="s"]');
      }
      live.push(el);
    });
    if (!live.length) return;

    var timer = null;
    function tick() {
      var now = Date.now();
      for (var i = live.length - 1; i >= 0; i--) {
        paint(live[i], now);
        if (live[i]._closed) live.splice(i, 1); // stop tracking finished ones
      }
      if (!live.length && timer) { clearInterval(timer); timer = null; }
    }
    function start() { if (!timer) { tick(); timer = setInterval(tick, 1000); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    tick(); // immediate fill, no waiting a second
    start();
    // pause when tab hidden, recompute on return (clock-based, so it stays accurate)
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });
  }

  function boot() {
    document.querySelectorAll('.cb-shop').forEach(function (root) {
      initReveal(root);
      initCounts(root);
    });
  }
  if (document.readyState !== 'loading') { boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }
})();
